import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { HiOutlineExclamationTriangle } from 'react-icons/hi2';
import Button from 'src/components/button/button';

type GuardErrorProps = {
   onRetry: () => void;
};

const GuardError = ({ onRetry }: GuardErrorProps) => {
   const [t] = useTranslation();

   return (
      <motion.div
         className='flex flex-col items-center text-center max-w-md mx-auto py-10'
         role='alert'
         initial={{ opacity: 0, y: 10 }}
         animate={{ opacity: 1, y: 0 }}
         transition={{ duration: 0.3 }}
      >
         <div className='bg-orgLightPrimary rounded-full flex items-center justify-center h-[70px] w-[70px]'>
            <HiOutlineExclamationTriangle className='w-7.5 h-7.5 text-orgPrimary' />
         </div>
         <h2 className='mb-0 text-black font-semibold text-3xl mt-7.5'>{t('guards.genericError.title')}</h2>
         <p className='mb-0 text-twGray text-xl mt-3.5'>{t('guards.genericError.content')}</p>
         <Button org pill className='mt-7.5 h-9 px-5 text-sm font-semibold border-0' onClick={onRetry}>
            {t('guards.genericError.retry')}
         </Button>
      </motion.div>
   );
};

export default GuardError;
